module.exports = __webpack_public_path__ + "b5e97230fd57dccc361d47600d556f43.svg";